import { useContext, type ReactNode } from "react";
import { Link } from "react-router-dom";
import { RebalanceContext } from "../RebalanceInfo";

// A link of the Explain view. The admin Explain viewer (the caller that gives
// a check, `doc-admin-explain-viewer-01a188565c071eb0` R31) shows its text with
// no link: the household, model and Cash & Billing pages are firm scoped and do
// not load for another firm.
export function useExplainLinksEnabled(): boolean {
  return useContext(RebalanceContext).givenCheck === undefined;
}

export default function ExplainLink({
  to,
  children,
}: {
  to: string;
  children: ReactNode;
}) {
  const enabled = useExplainLinksEnabled();
  return enabled ? <Link to={to}>{children}</Link> : <>{children}</>;
}
